import { useFetch } from "@/lib/api";
import { Panel } from "@/components/common";

const share = (w) => (w > 1 ? `+${Math.round((w - 1) * 100)}% share` : w < 1 ? `${Math.round((w - 1) * 100)}% share` : "even share");

export const ReplyRanking = () => {
  const { data } = useFetch("/oneplace/senders/ranking");
  if (!data || !data.rows.length) return null;
  return (
    <Panel title={`Reply rate ranking · last ${data.days} days`} data-testid="reply-ranking">
      <ol className="space-y-2">
        {data.rows.map((r, i) => (
          <li key={r.sender} className="flex items-center gap-3 text-sm" data-testid={`ranking-row-${r.sender}`}>
            <span className="w-5 text-zinc-500 font-mono">{i + 1}</span>
            <span className="flex-1 text-white truncate">{r.label}</span>
            <span className="font-mono tabular-nums w-16 text-right" data-testid={`ranking-rate-${r.sender}`}>{r.rate}%</span>
            <span className="text-xs text-zinc-500 w-40 text-right">{r.replies} replies / {r.sent} sent</span>
            <span className={`text-xs w-28 text-right ${r.weight > 1 ? "text-emerald-400" : r.weight < 1 ? "text-amber-400" : "text-zinc-500"}`} data-testid={`ranking-weight-${r.sender}`}>
              {r.eligible ? share(r.weight) : `needs ${data.min_sends} sends`}
            </span>
          </li>
        ))}
      </ol>
      <p className="text-[11px] text-zinc-500 mt-3">New prospects lean towards the senders with better reply rates (between half and one-and-a-half times an even share), always within each sender's daily limit. Follow-ups stay with the sender of Email 1.</p>
    </Panel>
  );
};
